module.exports = __webpack_public_path__ + "img/ilustrasi-proses.4320a210.gif";